<template>
  <PartnersGrid :partners="partners">
    <!-- <a
      href="mailto:info@shopcamp.cz?subject=Chci se stát hlavním partnerem"
      class="flex flex-col items-center justify-center w-full h-full font-medium transition-all duration-150 cursor-pointer group hover:opacity-80 text-brand-blue"
    >
      <svg
        class="mb-1 transition-all duration-300 transform group-hover:scale-110"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM16.25 12.75H12.75V16.25C12.75 16.6645 12.4145 17 12 17C11.5855 17 11.25 16.6645 11.25 16.25V12.75H7.75C7.3355 12.75 7 12.4145 7 12C7 11.5855 7.3355 11.25 7.75 11.25H11.25V7.75C11.25 7.3355 11.5855 7 12 7C12.4145 7 12.75 7.3355 12.75 7.75V11.25H16.25C16.6645 11.25 17 11.5855 17 12C17 12.4145 16.6645 12.75 16.25 12.75Z"
          fill="#2699C6"
        />
      </svg>
      Chci být hlavní partner
    </a> -->
  </PartnersGrid>
</template>

<script setup>
import PartnersGrid from "../PartnersGrid.vue";


defineProps({
  partners: {
    type: Array,
    default: () => [],
  },
});

// const MainPartners = [
//   {
//     src: "/assets/partners/advisio.png",
//     name: "Advisio",
//     href: "https://www.advisio.cz/",
//   },
//   {
//     src: "/assets/partners/affilbox.jpeg",
//     name: "AffilBox",
//     href: "https://www.affilbox.cz/",
//   },
//    {
//     src: "/assets/partners/balikobot.svg",
//     name: "Balikobot",
//     href: "https://www.balikobot.cz/",
//   },
//   {
//     src: "/assets/partners/barton.png",
//     name: "Bartoň studio",
//     href: "https://www.bartonstudio.cz/",
//   },
//   {
//     src: "/assets/partners/bidding-fox.png",
//     name: "Bidding Fox",
//     href: "https://www.bidding-fox.cz/",
//   },
//   {
//     src: "/assets/partners/conviu.svg",
//     name: "Conviu",
//     href: "https://conviu.com/",
//   },
//   {
//     src: "/assets/partners/ecomail.png",
//     name: "Ecomail",
//     href: "https://ecomail.cz/",
//   },
//   {
//     src: "/assets/partners/freelo.png",
//     name: "Freelo",
//     href: "https://www.freelo.cz/",
//   },
//   {
//     src: "/assets/partners/kaufland.png",
//     name: "Kaufland",
//     href: "https://www.kaufland.de/",
//   },
//   {
//     src: "/assets/partners/mergado.png",
//     name: "Mergado",
//     href: "https://www.mergado.cz/",
//   },
//   {
//     src: "/assets/partners/notino.png",
//     name: "Notino",
//     href: "https://www.notino.cz/",
//   },
//   {
//     src: "/assets/partners/postabezhranic.png",
//     name: "Pošta bez hranic",
//     href: "https://www.postabezhranic.cz/",
//   },
//   {
//     src: "/assets/partners/smartemailing.png",
//     name: "Smartemailing",
//     href: "https://www.smartemailing.cz/",
//   },
//   {
//     src: "/assets/partners/thimm.png",
//     name: "Thimm",
//     href: "https://www.thimm.cz/",
//   },
//   {
//     src: "/assets/partners/vshosting.png",
//     name: "VSHosting",
//     href: "https://vshosting.cz/",
//   },
//   {
//     src: "/assets/partners/zasilkovna.png",
//     name: "Zásilkovna",
//     href: "https://www.zasilkovna.cz/",
//   },

// ];

</script>

<style>
</style>
